import PropTypes from 'prop-types'
import { navigate } from '@patched/hookrouter'
import { getCurrentUserId, logout } from '@/api/auth-service'
import { routes } from '../../router'
import { Button } from '@/common/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/common/components/ui/dropdown-menu'
import { Avatar, AvatarFallback } from '@/common/components/ui/avatar'
import { LampDesk, LogOut } from 'lucide-react'

function formatDisplayName(email) {
  const userName = String(email || 'My Account').split('@')[0].replace('.', ' ')
  const parts = userName.split(' ').filter(Boolean)

  return {
    capUserName: parts
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' '),
    initials: parts.map((word) => word.charAt(0).toUpperCase()).join(''),
  }
}

function AppHeader({ isOps }) {
  const msEmail = getCurrentUserId() || 'My Account'
  const { capUserName, initials } = formatDisplayName(msEmail)

  return (
    <header className="bg-white w-full h-[100px] fixed top-0 left-0 flex justify-between items-center border-b border-[#dee2e6] z-[111] px-10">
      <div className="flex items-center">
        <div className="bg-[#007d8b] p-[6px] rounded-lg mr-2 inline-flex">
          <LampDesk color="#ffffff" />
        </div>
        <p className="font-bold text-2xl">Desk Booking System</p>
      </div>

      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="flex content-start hover:bg-transparent outline-none focus:outline-none focus-visible:border-transparent focus-visible:ring-0 focus-visible:ring-offset-0 data-[state=open]:bg-transparent">
            <div className="flex flex-col items-end">
              <span className="text-sm">{capUserName}</span>
              <span className="text-xs text-gray-500">Zinkworks Employee</span>
            </div>
            <Avatar>
              <AvatarFallback className="bg-[#007d8b] text-white">
                {initials}
              </AvatarFallback>
            </Avatar>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuGroup>
            <DropdownMenuLabel>My Account</DropdownMenuLabel>
            {isOps && (
              <DropdownMenuItem onSelect={() => navigate(routes.admin)}>
                Admin
              </DropdownMenuItem>
            )}
            <DropdownMenuItem onSelect={() => navigate(routes.seatMap)}>
              Main Page
            </DropdownMenuItem>
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuGroup>
            <DropdownMenuItem onSelect={logout}>
              Logout <LogOut />
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  )
}

AppHeader.propTypes = {
  isOps: PropTypes.bool.isRequired,
}

export default AppHeader
